import Intercom, * as intercom from '@intercom/messenger-js-sdk'
import { defineNuxtPlugin, useNuxtApp, useRuntimeConfig } from '#app'
import { useCountryConfig } from '~/composables/useCountryConfig'
import { useUserStore } from '~/stores/user'

declare module '#app' {
  // @ts-expect-error For some reason that might throw an error, though it's valid according to the docs
  interface NuxtApp {
    $intercom: typeof intercom
  }
}

export default defineNuxtPlugin(() => {
  const { intercomAppId } = useCountryConfig()
  const { intercomEnabled } = useRuntimeConfig().public
  const { $isDesktop } = useNuxtApp()
  const auth = useUserStore().auth
  if (intercomEnabled && $isDesktop()) {
    Intercom({
      app_id: intercomAppId,
      user_id: auth?.email,
      email: auth?.email,
      user_hash: auth?.intercomHash,
    })
  }
  return {
    provide: {
      intercom,
    },
  }
})
